import React from "react";
import { useState, useEffect } from "react";
import Swal from "sweetalert2";
import {
  collection,
  getDocs,
  serverTimestamp,
  updateDoc,
  setDoc,
  doc,
  addDoc,
  onSnapshot,
} from "firebase/firestore";
import { v4 as uuidv4 } from "uuid";
import { db } from "../firebaseConfig";
import Modal from "react-modal";
import TablaRemisiones from "./TablaRemisiones";
import "react-datepicker/dist/react-datepicker.css";
import Nav from "./Nav";
import { useNavContext } from "../context/NavContext";
import Sidebar from "./Sidebar";
import VendedorModal from "./VendedorModal";
import { useNumeroConfig } from "../hooks/useNumeroConfig";
import useArchivos from "../hooks/useArchivos";
import useProductos from "../hooks/useProductos";
import { flushSync } from "react-dom";
import { useFunctionsPrevia } from "../hooks/useFunctionsPrevia";

// Establece la función de inicialización de react-modal para evitar un aviso de desenfoque de accesibilidad
Modal.setAppElement("#root");

function MiniSelect({ value, onChange, options, width = 64, height = 40 }) {
  const [open, setOpen] = React.useState(false);
  const ref = React.useRef(null);

  // Cierra el menú si haces clic fuera
  React.useEffect(() => {
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  return (
    <div
      ref={ref}
      style={{
        position: "relative",
        width,
        height,
        display: "inline-block",
      }}
    >
      <button
        type="button"
        aria-haspopup="listbox"
        aria-expanded={open}
        onClick={() => setOpen((prev) => !prev)}
        style={{
          width: "100%",
          height: "100%",
          border: "none",
          borderLeft: "1px solid #ddd",
          background: "#fff",
          fontSize: 14,
          fontWeight: 500,
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          borderTopRightRadius: 8,
          borderBottomRightRadius: 8,
          boxShadow: "inset 0 0 0 1px #ddd",
          color: "#111",
          padding: 0,
        }}
      >
        <span style={{ position: "relative", top: "1px" }}>{value}</span>
        <i
          className="bi bi-caret-down-fill"
          style={{
            marginLeft: 6,
            fontSize: 12,
            color: "#666",
            position: "relative",
            top: "1px",
          }}
        />
      </button>

      {open && (
        <div
          role="listbox"
          style={{
            position: "absolute",
            top: "calc(100% + 6px)",
            right: 0,
            zIndex: 2000,
            minWidth: "100%",
            background: "#fff",
            border: "1px solid #e7e7ea",
            borderRadius: 8,
            boxShadow: "0 8px 24px rgba(0,0,0,.12)",
            padding: 4,
          }}
        >
          {options.map((opt) => {
            const selected = value === opt.value;
            return (
              <div
                key={opt.value}
                role="option"
                aria-selected={selected}
                onClick={() => {
                  onChange(opt.value);
                  setOpen(false);
                }}
                style={{
                  padding: "8px 12px",
                  borderRadius: 8,
                  fontSize: 14,
                  textAlign: "center",
                  cursor: "pointer",
                  background: selected ? "#eaf1ff" : "transparent",
                  color: selected ? "#0a66ff" : "#111",
                  transition: "background 0.15s",
                }}
              >
                {opt.label}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

function RemisionForm(props) {
  const { remision, closeModal, setRemisiones } = props;
  const [productos, setProductos] = useState([]);
  const {
    numero: numeroRemisionAuto,
    modo: modoNumeroRemision,
    abrirConfiguracion,
    NumeroConfigModalUI,
  } = useNumeroConfig("numeroRemision", {
    title: "Configurar número de remisión",
  });
  const {
    archivos,
    initArchivos,
    cargando,
    manejarArchivos,
    eliminarArchivo,
    descargarArchivo,
    obtenerIcono,
  } = useArchivos("remisiones");
  const {
    datos,
    descuento,
    añadirFila,
    eliminar,
    actualizarCantidad,
    handleInputChange,
    filteredProductos,
    activeRow,
    subtotalConDesc,
    iva,
    total,
    obtenerIVA,
    calcularSubtotal,
    setDatos,
    setFilteredProductos,
    agregarBulk,
    setDescuento,
  } = useProductos(
    remision?.productosSeleccionados || [],
    remision?.descuento || 0,
    productos
  );
  const [cliente, setCliente] = useState("");
  const [clientes, setClientes] = useState([]);
  const [observacion, setObservacion] = useState("");
  const [condicion, setCondicion] = useState("");
  const [vendedores, setVendedores] = useState([]);
  const [vendedorNombre, setVendedorNombre] = useState("");
  const [vendedorCorreo, setVendedorCorreo] = useState("");
  const [modalVendedorIsOpen, setModalVendedorIsOpen] = useState(false);
  const [referencia, setReferencia] = useState("");
  const [asunto, setAsunto] = useState("");
  const [mostrarTabla] = useState(false);
  const [modoEdicion, setModoEdicion] = useState(false);
  const [formDirty, setFormDirty] = useState(false);
  const { proximasAVencer, proximosEventos } = useNavContext();
  const [numeroCotizacion, setNumeroCotizacion] = useState("");
  const [fechaRemision, setFechaRemision] = useState(new Date());
  const [atencion, setAtencion] = useState("");
  const [planta, setPlanta] = useState("");
  const [area, setArea] = useState("");
  const [notas, setNotas] = useState("");
  const [divisa, setDivisa] = useState("MXN");
  const [terminos, setTerminos] = useState("");
  const [incoterm, setIncoterm] = useState("");
  const [numeroSobrescrito, setNumeroSobrescrito] = useState(null);
  const { formatDate } = useFunctionsPrevia();
  const [tipoDescuentoGlobal, setTipoDescuentoGlobal] = useState("%");

  useEffect(() => {
    if (remision) {
      setModoEdicion(true);

      // Campos básicos
      setNumeroSobrescrito(remision.numeroRemision ?? null);
      setCliente(remision.cliente);
      setNumeroCotizacion(remision.numeroCotizacion);
      setFechaRemision(
        remision.fechaRemision ? new Date(remision.fechaRemision) : new Date()
      );
      setCondicion(remision.condicion);
      setAtencion(remision.atencion);
      setReferencia(remision.referencia);
      setObservacion(remision.observacion);
      setDivisa(remision.divisa);
      setPlanta(remision.planta);
      setArea(remision.area);
      setVendedorNombre(remision.vendedorNombre ?? "");
      setVendedorCorreo(remision.vendedorCorreo ?? "");
      setIncoterm(remision.incoterm ?? "");
      setAsunto(remision.asunto);

      // Inicializa productos y descuento en el hook con las filas de la remisión
      setDatos(
        (remision.productosSeleccionados ?? []).map((p) => ({
          id: uuidv4(),
          ...p,
        }))
      );
      setDescuento(parseFloat(remision.descuento) || 0);

      // Notas y términos
      setNotas(remision.notas);
      setTerminos(remision.terminos);

      // Inicializa archivos
      initArchivos(remision.archivos ?? []);
    } else {
      setModoEdicion(false);
      setNumeroSobrescrito(null);

      // Formulario nuevo: exactamente una fila vacía
      setDatos([
        {
          id: uuidv4(),
          nombre: "",
          descripcion: "",
          numeroDeParteCliente: "",
          cantidad: 1,
          tarifa: 0,
          iva: 0,
          descuento: 0,
          tipoDescuento: "%",
          importe: 0,
        },
      ]);
      setDescuento(0);

      // Limpia archivos
      initArchivos([]);
    }
  }, [remision, setDatos, setDescuento, initArchivos]);

  useEffect(() => {
    // 1) Suscribirse a vendedores en tiempo real
    const unsubscribeVendedores = onSnapshot(
      collection(db, "vendedores"),
      (snap) =>
        setVendedores(snap.docs.map((d) => ({ id: d.id, ...d.data() }))),
      (err) => console.error("Error al suscribirse a vendedores:", err)
    );

    // 2) Cargar clientes y productos una vez
    const fetchClientesYProductos = async () => {
      try {
        // Clientes
        const clientesSnap = await getDocs(collection(db, "clientes"));
        const clientesList = clientesSnap.docs.map((d) => ({
          id: d.id,
          ...d.data(),
        }));
        // Filtrar únicos por empresa
        const clientesUnicos = clientesList.filter(
          (c, i, arr) => arr.findIndex((x) => x.empresa === c.empresa) === i
        );
        setClientes(clientesUnicos);

        // Productos
        const productosSnap = await getDocs(collection(db, "productos"));
        const productosList = productosSnap.docs.map((d) => ({
          id: d.id,
          ...d.data(),
          tipoDescuento: "cantidad",
          valorDescuento: 0,
        }));
        setProductos(productosList);
      } catch (error) {
        console.error("Error al obtener clientes o productos:", error);
      }
    };

    fetchClientesYProductos();

    // Cleanup al desmontar
    return () => {
      unsubscribeVendedores();
    };
  }, []);

  const openModalVendedor = () => {
    setModalVendedorIsOpen(true);
  };

  const closeModalVendedor = () => {
    setModalVendedorIsOpen(false);
  };

  const guardar = async (e) => {
    e.preventDefault();

    // 1) Validación básica
    if (!cliente || !fechaRemision) {
      return Swal.fire({
        icon: "error",
        title: "Campos obligatorios faltantes",
        text: "Por favor completa los campos: Cliente y Fecha de la Remisión.",
      });
    }

    // 2) Número de remisión efectivo
    const numeroEfectivo = numeroSobrescrito ?? numeroRemisionAuto;

    try {
      // 3) Verificar duplicados
      const snapshot = await getDocs(collection(db, "remisiones"));
      const dup = snapshot.docs.find(
        (d) => d.data().numeroRemision === numeroEfectivo
      );
      if (dup && (!modoEdicion || (remision?.id && remision.id !== dup.id))) {
        return Swal.fire({
          icon: "error",
          title: "Número de remisión duplicado",
          text: `El número "${numeroEfectivo}" ya existe. Usa otro.`,
        });
      }

      // 4) Nombre de cliente
      const sel = clientes.find((c) => c.id === cliente);
      const nombreCliente = sel ? sel.empresa || sel.nombre : "";

      // 5) Preparo objeto con TODO el estado, incluidos los archivos ya con URL
      const remisionData = {
        cliente,
        nombreCliente,
        numeroRemision: numeroEfectivo,
        numeroCotizacion,
        fechaRemision: fechaRemision.toISOString(),
        atencion,
        referencia,
        observacion,
        planta,
        vendedorNombre,
        vendedorCorreo,
        condicion,
        area,
        divisa,
        incoterm,
        asunto,
        productosSeleccionados: datos,
        total,
        notas,
        terminos,
        descuento,
        createdAt: serverTimestamp(),
        estado: "Pendiente",
        archivos,
      };

      // 6) CREATE o UPDATE
      if (modoEdicion && remision?.id) {
        // Actualizar existente
        await updateDoc(doc(db, "remisiones", remision.id), remisionData);
        // Reflejar cambio en la lista padre si es necesario
        setRemisiones?.((prev) =>
          prev.map((r) =>
            r.id === remision.id ? { id: remision.id, ...remisionData } : r
          )
        );
        await Swal.fire({
          icon: "success",
          title: "Remisión actualizada",
          showConfirmButton: false,
          timer: 1500,
        });
      } else {
        // Crear nueva
        await addDoc(collection(db, "remisiones"), remisionData);

        // Auto-incremento si está en automático
        if (modoNumeroRemision === "auto") {
          const m = numeroEfectivo.match(/^(.+?)(\d+)$/);
          if (m) {
            const [, pref, num] = m;
            const next = String(Number(num) + 1).padStart(num.length, "0");
            await setDoc(
              doc(db, "configuracion", "numeroRemision"),
              { modo: "auto", prefijo: pref, siguienteNumero: Number(next) },
              { merge: true }
            );
          }
        }

        await Swal.fire({
          icon: "success",
          title: "Remisión guardada",
          showConfirmButton: false,
          timer: 1500,
        });
      }

      // 7) Reset dirty + cierre modal (sin recargar)
      flushSync(() => {
        setFormDirty(false);
      });
      closeModal();
    } catch (err) {
      console.error(err);
      Swal.fire({
        icon: "error",
        title: "Error al guardar",
        text: err.message,
      });
    }
  };

  const handleCancel = () => {
    if (formDirty) {
      Swal.fire({
        title: "¿Seguro que quieres salir?",
        text: "Se perderán los cambios realizados",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sí, salir",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.isConfirmed) {
          // Cerrar el modal usando la función pasada como prop
          closeModal();
          setFormDirty(false); // Opcional: resetea el estado si es necesario
        }
      });
    } else {
      // Si no hay cambios, simplemente cierra el modal
      closeModal();
    }
  };

  return (
    <>
      <Nav
        proximasAVencer={proximasAVencer}
        proximosEventos={proximosEventos}
      />

      <Sidebar />

      <div className="cotizacion-form">
        <form>
          <div>
            <div className="group apartado">
              <label htmlFor="cliente" className="required">
                Razón Social*
              </label>
              <select
                id="cliente"
                name="cliente"
                value={cliente}
                onChange={(e) => {
                  setCliente(e.target.value);
                  setFormDirty(true); // Marcar que el formulario ha sido modificado
                }}
              >
                <option value="">Seleccionar cliente</option>
                {clientes
                  .slice() // Crea una copia para evitar modificar el estado original
                  .sort((a, b) => a.empresa.localeCompare(b.empresa)) // Ordenar alfabéticamente
                  .map((cliente) => (
                    <option key={cliente.id} value={cliente.id}>
                      {cliente.empresa}
                    </option>
                  ))}
              </select>
            </div>

            <br />

            <div className="group">
              <label htmlFor="numeroRemision" className="required">
                No. Remisión#*
              </label>
              <div className="input-wrapper input-wrapper-expanded">
                <input
                  type="text"
                  id="numeroRemision"
                  name="numeroRemision"
                  className="numeroRemision-input"
                  // Si hay un valor manual (override), lo mostramos; si no, el automático
                  value={numeroSobrescrito ?? numeroRemisionAuto}
                  onChange={(e) => {
                    if (modoNumeroRemision === "manual") {
                      const v = e.target.value.trim();
                      setNumeroSobrescrito(v === "" ? null : v);
                    }
                  }}
                  disabled={modoNumeroRemision === "auto"} // deshabilitado en auto
                />
                <button
                  type="button"
                  className="icon-button"
                  onClick={abrirConfiguracion}
                >
                  <i className="bi bi-gear-fill"></i>
                </button>
              </div>
            </div>

            <div className="group fechas">
              <div className="group">
                <label htmlFor="numeroCotizacion">No. Cotización#</label>
                <input
                  type="text"
                  id="numeroCotizacion"
                  name="numeroCotizacion"
                  value={numeroCotizacion}
                  onChange={(e) => {
                    setNumeroCotizacion(e.target.value);
                    setFormDirty(true); // Marcar que el formulario ha sido modificado
                  }}
                />
              </div>

              <div className="group">
                <label htmlFor="vendedor">Agente</label>
                <select
                  id="vendedorNombre"
                  name="vendedorNombre"
                  value={
                    vendedores.find((v) => v.nombre === vendedorNombre)?.id ||
                    ""
                  }
                  style={{ width: "42%" }}
                  onChange={(e) => {
                    const selectedValue = e.target.value;
                    if (selectedValue === "agregar-nuevo") {
                      openModalVendedor(); // Solo abre el modal
                    } else {
                      const vendedorSeleccionado = vendedores.find(
                        (v) => v.id === selectedValue
                      );
                      if (vendedorSeleccionado) {
                        setVendedorNombre(vendedorSeleccionado.nombre);
                        setVendedorCorreo(vendedorSeleccionado.correo);
                      }
                    }
                  }}
                >
                  <option value="">Seleccionar vendedor</option>
                  {vendedores.map((v) => (
                    <option key={v.id} value={v.id}>
                      {v.nombre}
                    </option>
                  ))}
                  <option value="agregar-nuevo">Agregar nuevo vendedor</option>
                </select>
              </div>

              <VendedorModal
                isOpen={modalVendedorIsOpen}
                onClose={closeModalVendedor}
                initialNombre={vendedorNombre}
                initialCorreo={vendedorCorreo}
                onSelect={(v) => {
                  setVendedorNombre(v.nombre);
                  setVendedorCorreo(v.correo);
                }}
              />
            </div>

            <div className="group fechas">
              <div className="group">
                <label htmlFor="fecha-remision" className="required">
                  Fecha*
                </label>
                <input
                  type="text"
                  id="fecha-remision"
                  name="fecha-remision"
                  value={fechaRemision ? formatDate(fechaRemision) : ""}
                  readOnly
                  style={{ width: "40%" }}
                />
              </div>

              <div className="group">
                <label htmlFor="atencion">Atención</label>
                <input
                  type="text"
                  id="atencion"
                  name="atencion"
                  value={atencion}
                  onChange={(e) => {
                    setAtencion(e.target.value);
                    setFormDirty(true); // Marcar el formulario como modificado
                  }}
                />
              </div>
            </div>

            <div className="group fechas">
              <div className="group">
                <label htmlFor="referencia">Referencia Interna</label>
                <input
                  type="text"
                  id="referencia"
                  name="referencia"
                  value={referencia}
                  onChange={(e) => {
                    setReferencia(e.target.value);
                    setFormDirty(true);
                  }}
                />
              </div>

              <div className="group">
                <label htmlFor="condicion">Cond. Pago</label>
                <input
                  type="text"
                  id="condicion"
                  name="condicion"
                  value={condicion}
                  onChange={(e) => {
                    setCondicion(e.target.value);
                    setFormDirty(true);
                  }}
                />
              </div>
            </div>

            <div className="group fechas">
              <div className="group">
                <label htmlFor="incoterm">Incoterms:</label>
                <select
                  id="incoterm"
                  name="incoterm"
                  value={incoterm}
                  onChange={(e) => {
                    setIncoterm(e.target.value);
                    setFormDirty(true);
                  }}
                  style={{ width: "42%" }}
                >
                  <option value="ninguno">Ninguno</option>
                  <option value="exw">EXW</option>
                  <option value="fob">FOB</option>
                  <option value="cif">CIF</option>
                  <option value="dap">DAP</option>
                  <option value="ddp">DDP</option>
                </select>
              </div>
            </div>

            <hr
              style={{
                marginBottom: "30px",
                marginTop: "20px",
                border: "1px solid #f9f9fb",
              }}
            />

            <div className="group fechas">
              <div className="group">
                <label
                  style={{ alignSelf: "flex-start" }}
                  htmlFor="observacion"
                >
                  Observaciones
                </label>
                <textarea
                  type="text"
                  id="observacion"
                  name="observacion"
                  value={observacion}
                  onChange={(e) => {
                    setObservacion(e.target.value);
                    setFormDirty(true); // Marcar que el formulario ha sido modificado
                  }}
                ></textarea>
              </div>
              <div className="group">
                <label htmlFor="planta">Planta</label>
                <input
                  type="text"
                  id="planta"
                  name="planta"
                  value={planta}
                  onChange={(e) => {
                    setPlanta(e.target.value);
                    setFormDirty(true); // Marcar el formulario como modificado
                  }}
                />
              </div>
            </div>

            <div className="group fechas">
              <div className="group">
                <label htmlFor="area">Área</label>
                <input
                  type="text"
                  id="area"
                  name="area"
                  value={area}
                  onChange={(e) => {
                    setArea(e.target.value);
                    setFormDirty(true); // Marcar el formulario como modificado
                  }}
                />
              </div>
              <div className="group">
                <label htmlFor="divisa">Divisa</label>
                <select
                  id="divisa"
                  name="divisa"
                  value={divisa}
                  onChange={(e) => {
                    setDivisa(e.target.value);
                    setFormDirty(true); // Marcar el formulario como modificado
                  }}
                >
                  <option value="MXN">MXN</option>
                  <option value="USD">USD</option>
                </select>
              </div>
            </div>

            <br />

            <div className="group">
              <label htmlFor="asunto">Asunto</label>
              <input
                type="text"
                id="asunto"
                name="asunto"
                value={asunto}
                onChange={(e) => {
                  setAsunto(e.target.value);
                  setFormDirty(true); // Marcar el formulario como modificado
                }}
              />
            </div>

            <br />

            <div className="apartado2">Tabla de productos</div>

            <div>
              {/* Contenedor para la tabla y los botones */}
              <div
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  width: "100%",
                }}
              >
                {/* Tabla general */}

                <div>
                  <table className="productos-table">
                    <thead>
                      <tr>
                        <th>Detalles del Artículo</th>
                        <th style={{ textAlign: "center" }}>Modelo</th>
                        <th id="cantidad-col">Cantidad</th>
                        <th id="precio-col">Precio</th>
                        <th id="descuento-col">Descuento</th>
                        <th id="importe-col">Importe</th>
                      </tr>
                    </thead>
                    <tbody>
                      {datos.map((producto) => (
                        <tr key={producto.id} style={{ position: "relative" }}>
                          <td>
                            <div style={{ position: "relative" }}>
                              <textarea
                                className="list-products"
                                value={
                                  producto.descripcion || producto.nombre || ""
                                }
                                onChange={(e) => {
                                  handleInputChange(e, producto.id);
                                  setFormDirty(true);
                                }}
                                onBlur={() =>
                                  setTimeout(
                                    () => setFilteredProductos([]),
                                    100
                                  )
                                }
                                placeholder="Escriba para seleccionar un artículo"
                                style={{
                                  width: "600px",
                                  height: "130px",
                                  padding: "8px",
                                  fontSize: "14px",
                                  lineHeight: "1.5",
                                  resize: "vertical",
                                  overflow: "auto",
                                  whiteSpace: "pre-wrap",
                                  fontFamily: "Arial, sans-serif",
                                }}
                              />
                              {activeRow === producto.id &&
                                filteredProductos.length > 0 && (
                                  <ul
                                    style={{
                                      position: "absolute",
                                      top: "105%",
                                      left: 0,
                                      width: "100%",
                                      backgroundColor: "#fff",
                                      border: "1px solid #cecece",
                                      borderRadius: "5px",
                                      zIndex: 10,
                                      maxHeight: "150px",
                                      overflowY: "auto",
                                      listStyle: "none",
                                      padding: "5px",
                                      margin: 0,
                                    }}
                                  >
                                    {filteredProductos.map((prod) => (
                                      <li
                                        key={prod.id}
                                        onMouseDown={() => {
                                          handleInputChange(
                                            { target: { value: prod.nombre } },
                                            producto.id
                                          );
                                          setFormDirty(true);
                                        }}
                                        style={{
                                          padding: "5px",
                                          cursor: "pointer",
                                          backgroundColor: "#f9f9f9",
                                          marginBottom: "2px",
                                        }}
                                      >
                                        {prod.nombre}
                                      </li>
                                    ))}
                                  </ul>
                                )}
                            </div>
                          </td>

                          <td>
                            <input
                              type="text"
                              value={
                                producto.modelo ||
                                producto.numeroDeParteCliente ||
                                ""
                              }
                              onChange={(e) => {
                                const modelo = e.target.value;
                                setDatos((prev) =>
                                  prev.map((item) =>
                                    item.id === producto.id
                                      ? { ...item, modelo }
                                      : item
                                  )
                                );
                                setFormDirty(true);
                              }}
                            />
                          </td>

                          <td id="cantidad-col">
                            <input
                              type="number"
                              value={producto.cantidad || 1}
                              onChange={(e) => {
                                actualizarCantidad(
                                  producto.id,
                                  parseInt(e.target.value) || 0
                                );
                                setFormDirty(true);
                              }}
                            />
                          </td>

                          <td id="precio-col">
                            <input
                              type="text"
                              inputMode="decimal"
                              value={(producto.tarifa ?? "").toString()}
                              onChange={(e) => {
                                const raw = e.target.value.replace(",", "."); // acepta . o ,
                                // permite vacío, "0.", ".5", "10.3", etc.
                                if (
                                  !/^(\d+(\.\d*)?|\.\d*)?$/.test(raw) &&
                                  raw !== ""
                                )
                                  return;

                                setDatos((prev) =>
                                  prev.map((item) =>
                                    item.id === producto.id
                                      ? {
                                          ...item,
                                          // guardamos el string mientras escribe para no perder el punto
                                          tarifa: raw,
                                          // calculamos importe con lo que haya (si está vacío -> 0)
                                          importe:
                                            raw === ""
                                              ? 0
                                              : (parseFloat(raw) || 0) *
                                                (item.cantidad || 0),
                                        }
                                      : item
                                  )
                                );
                                setFormDirty(true);
                              }}
                              onBlur={(e) => {
                                // normalizamos a número al salir del campo
                                const num =
                                  parseFloat(
                                    e.target.value.replace(",", ".")
                                  ) || 0;
                                setDatos((prev) =>
                                  prev.map((item) =>
                                    item.id === producto.id
                                      ? {
                                          ...item,
                                          tarifa: num,
                                          importe: num * (item.cantidad || 0),
                                        }
                                      : item
                                  )
                                );
                              }}
                              style={{
                                width: "100%",
                                textAlign: "right",
                                padding: "8px",
                                fontSize: "14px",
                                borderRadius: "4px",
                              }}
                            />
                          </td>

                          <td id="descuento-col">
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                height: "32px",
                                border: "1px solid #ccc",
                                borderRadius: "4px",
                                overflow: "hidden",
                                width: "100%",
                              }}
                            >
                              <input
                                type="text"
                                inputMode="decimal"
                                value={(producto.descuento ?? "").toString()}
                                onChange={(e) => {
                                  const raw = e.target.value.replace(",", "."); // acepta coma o punto
                                  // permite vacío, ".5", "0.", "10.5", etc.
                                  if (!/^(\d+(\.\d*)?|\.\d*)?$/.test(raw))
                                    return;

                                  setDatos((prev) =>
                                    prev.map((item) => {
                                      if (item.id !== producto.id) return item;

                                      const qty = Number(item.cantidad) || 0;
                                      const price =
                                        parseFloat(item.tarifa) || 0;
                                      const tipo = item.tipoDescuento || "%";
                                      const dnum =
                                        raw === "" || raw === "."
                                          ? 0
                                          : Math.max(parseFloat(raw) || 0, 0);

                                      const importe =
                                        tipo === "%"
                                          ? price * qty * (1 - dnum / 100)
                                          : Math.max(price * qty - dnum, 0);

                                      return {
                                        ...item,
                                        descuento: raw,
                                        importe,
                                      };
                                    })
                                  );
                                  setFormDirty(true);
                                }}
                                onBlur={(e) => {
                                  let d =
                                    parseFloat(
                                      e.target.value.replace(",", ".")
                                    ) || 0;
                                  if (producto.tipoDescuento === "%" && d > 100)
                                    d = 100;
                                  if (d < 0) d = 0;

                                  setDatos((prev) =>
                                    prev.map((item) => {
                                      if (item.id !== producto.id) return item;
                                      const qty = Number(item.cantidad) || 0;
                                      const price =
                                        parseFloat(item.tarifa) || 0;
                                      const tipo = item.tipoDescuento || "%";
                                      const importe =
                                        tipo === "%"
                                          ? price * qty * (1 - d / 100)
                                          : Math.max(price * qty - d, 0);
                                      return { ...item, descuento: d, importe };
                                    })
                                  );
                                }}
                                style={{
                                  flex: 1,
                                  border: "none",
                                  outline: "none",
                                  textAlign: "right",
                                  padding: "0 12px",
                                  fontSize: "16px",
                                  lineHeight: "32px",
                                }}
                              />
                              <div
                                style={{
                                  position: "relative",
                                  width: "50px",
                                  height: "100%",
                                }}
                              >
                                <select
                                  value={producto.tipoDescuento || "%"}
                                  onChange={(e) => {
                                    const tipo = e.target.value;
                                    setDatos((prev) =>
                                      prev.map((item) => {
                                        if (item.id !== producto.id)
                                          return item;
                                        const qty = Number(item.cantidad) || 0;
                                        const price =
                                          parseFloat(item.tarifa) || 0;
                                        const d =
                                          parseFloat(
                                            String(item.descuento).replace(
                                              ",",
                                              "."
                                            )
                                          ) || 0;

                                        const importe =
                                          tipo === "%"
                                            ? price * qty * (1 - d / 100)
                                            : Math.max(price * qty - d, 0);

                                        return {
                                          ...item,
                                          tipoDescuento: tipo,
                                          importe,
                                        };
                                      })
                                    );
                                    setFormDirty(true);
                                  }}
                                  style={{
                                    appearance: "none",
                                    WebkitAppearance: "none",
                                    MozAppearance: "none",
                                    width: "100%",
                                    height: "100%",
                                    border: "none",
                                    outline: "none",
                                    padding: "0 12px",
                                    fontSize: "16px",
                                    lineHeight: "32px",
                                    backgroundColor: "#f4f4f4",
                                    textAlign: "center",
                                    cursor: "pointer",
                                  }}
                                >
                                  <option value="%">%</option>
                                  <option value="$">$</option>
                                </select>
                                <i
                                  style={{
                                    position: "absolute",
                                    right: "8px",
                                    top: "50%",
                                    transform: "translateY(-50%)",
                                    pointerEvents: "none",
                                    color: "#666",
                                    fontSize: "12px",
                                  }}
                                />
                              </div>
                            </div>
                          </td>

                          <td
                            id="importe-col"
                            style={{ textAlign: "right", paddingRight: "10px" }}
                          >
                            $
                            {parseFloat(producto.importe || 0).toLocaleString(
                              "en-US",
                              {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              }
                            )}
                          </td>

                          {/* Botones de acción */}
                          <div
                            style={{
                              position: "absolute",
                              right: "-75px",
                              top: "50%",
                              transform: "translateY(-50%)",
                              display: "flex",
                            }}
                          >
                            <button
                              type="button"
                              style={{
                                background: "none",
                                border: "none",
                                cursor: "pointer",
                              }}
                            >
                              <i
                                className="bi bi-three-dots-vertical"
                                style={{ fontSize: "1.2rem" }}
                              />
                            </button>
                            <button
                              type="button"
                              style={{
                                background: "none",
                                border: "none",
                                color: "#dc3545",
                                cursor: "pointer",
                              }}
                              onClick={() => eliminar(producto.id)}
                            >
                              <i
                                className="bi bi-x-lg"
                                style={{ fontSize: "1.2rem" }}
                              />
                            </button>
                          </div>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <div className="acciones-tabla">
              <button onClick={añadirFila}>
                <i
                  style={{ color: "#007bff", fontSize: "16px" }}
                  className="bi bi-plus-circle-fill"
                ></i>
                Añadir nueva fila
              </button>
              <button type="button" onClick={() => agregarBulk(datos)}>
                <i
                  style={{ color: "#007bff", fontSize: "16px" }}
                  className="bi bi-plus-circle-fill"
                ></i>
                Agregar artículos a granel
              </button>
            </div>

            <div className="data-container">
              <div className="notes-container">
                <label htmlFor="customer-notes">Notas del Cliente</label>
                <textarea
                  id="customer-notes"
                  placeholder="Escribe tus notas aquí..."
                  value={notas}
                  onChange={(e) => {
                    setNotas(e.target.value);
                    setFormDirty(true); // Marcar el formulario como modificado
                  }}
                ></textarea>
              </div>

              <div className="totales-container">
                {/* Subtotal después de aplicar el descuento */}
                <div className="row">
                  <span className="label">Subtotal</span>
                  <span>
                    $
                    {subtotalConDesc.toLocaleString("en-US", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </span>
                </div>

                {/* Descuento global */}
                <div className="row descuento">
                  <span className="label">Descuento</span>

                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      border: "1px solid #ddd",
                      borderRadius: "8px",
                      overflow: "visible",
                      position: "relative",
                      height: 40,
                      minWidth: 180,
                      background: "#fff",
                    }}
                  >
                    <input
                      type="text"
                      inputMode="decimal"
                      value={(descuento ?? "").toString()}
                      onChange={(e) => {
                        const raw = e.target.value.replace(",", ".");
                        if (!/^(\d+(\.\d*)?|\.\d*)?$/.test(raw)) return;
                        setDescuento(raw === "" ? "" : raw);
                        setFormDirty(true);
                      }}
                      onBlur={(e) => {
                        let d =
                          parseFloat(e.target.value.replace(",", ".")) || 0;
                        if (tipoDescuentoGlobal === "%" && d > 100) d = 100;
                        if (
                          tipoDescuentoGlobal === "MXN" &&
                          d > calcularSubtotal()
                        )
                          d = calcularSubtotal();
                        if (d < 0) d = 0;
                        setDescuento(d);
                      }}
                      style={{
                        flex: 1,
                        border: "none",
                        outline: "none",
                        textAlign: "right",
                        padding: "0 12px",
                        fontSize: "16px",
                        lineHeight: "32px",
                        background: "transparent",
                      }}
                    />

                    <MiniSelect
                      value={tipoDescuentoGlobal}
                      options={[
                        { value: "%", label: "%" },
                        { value: "MXN", label: "MXN" },
                      ]}
                      onChange={(next) => {
                        setTipoDescuentoGlobal(next);
                        setDescuento((prev) => {
                          let d = parseFloat(prev) || 0;
                          if (next === "%" && d > 100) d = 100;
                          if (next === "MXN" && d > calcularSubtotal())
                            d = calcularSubtotal();
                          if (d < 0) d = 0;
                          return d;
                        });
                      }}
                    />
                  </div>

                  <span className="discount-percentage">
                    – $
                    {(tipoDescuentoGlobal === "%"
                      ? calcularSubtotal() *
                        ((parseFloat(descuento) || 0) / 100)
                      : Math.min(parseFloat(descuento) || 0, calcularSubtotal())
                    ).toLocaleString("en-US", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </span>
                </div>

                {/* IVA calculado */}
                <div className="row iva">
                  <span className="label">
                    IVA ({(obtenerIVA() * 100).toFixed(0)}%)
                  </span>
                  <span>
                    $
                    {iva.toLocaleString("en-US", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </span>
                </div>

                <hr />

                {/* Total final */}
                <div className="row total">
                  <span>Total ({divisa})</span>
                  <span className="total-amount">
                    $
                    {total.toLocaleString("en-US", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </span>
                </div>
              </div>
            </div>

            <div
              style={{
                backgroundColor: "#f9f9fb",
                padding: "8px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "flex-start",
                gap: "10px",
                width: "94%",
                marginTop: "30px",
                paddingBottom: "30px",
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
              }}
            >
              {/* Left Section: Términos y Condiciones */}
              <div className="terminos-container">
                <h4>Términos y condiciones</h4>
                <textarea
                  value={terminos}
                  onChange={(e) => {
                    setTerminos(e.target.value);
                    setFormDirty(true); // Marcar el formulario como modificado
                  }}
                />
              </div>

              {/* Right Section: File Upload */}
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  gap: "8px",
                  flex: "0 0 530px",
                  marginTop: "30px",
                }}
              >
                <label style={{ fontSize: "14px" }}>
                  Adjuntar archivo(s) a Estimación
                </label>

                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    border: "1px dashed #ccc",
                    borderRadius: "5px",
                    overflow: "hidden", // Eliminar cualquier contenido que se salga del borde
                  }}
                >
                  <label
                    style={{
                      padding: "8px 10px",
                      backgroundColor: "#fff",
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      cursor: "pointer",
                      whiteSpace: "nowrap", // Evitar que el contenido del botón se ajuste en varias líneas
                    }}
                  >
                    <i style={{ color: "#000" }} className="bi bi-upload"></i>
                    <span
                      style={{
                        fontSize: "14px",
                        color: "#000",
                        fontWeight: "lighter",
                      }}
                    >
                      Cargar archivo
                    </span>
                    <input
                      type="file"
                      style={{ display: "none" }} // Ocultar el input de archivo
                      accept=".csv,.xls,.xlsx,.doc,.docx,.pdf,.jpg,.jpeg,.png,.svg,.txt"
                      onChange={manejarArchivos}
                    />
                  </label>

                  <div
                    style={{
                      padding: "10px",
                      backgroundColor: "#fff",
                      borderLeft: "1px dashed #ccc", // Borde que conecta con el input
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      cursor: "pointer",
                      borderTopRightRadius: "auto", // Bordes redondeados en la esquina derecha
                      borderBottomRightRadius: "auto",
                      minWidth: "20px", // Evitar que el botón se haga demasiado pequeño
                      margin: "0", // Eliminar cualquier margen que agregue espacio extra
                    }}
                  >
                    <i
                      style={{
                        color: "#000",
                        fontSize: "14px", // Ajustar el tamaño del ícono
                      }}
                      className="bi bi-chevron-down"
                    ></i>
                  </div>
                </div>

                <p style={{ fontSize: "12px", color: "#888" }}>
                  Puedes cargar un máximo de 10 archivos, cada uno de 10 MB
                </p>

                {cargando && (
                  <p style={{ fontSize: "14px", color: "#888" }}>
                    Cargando archivo...
                  </p>
                )}

                {archivos.length > 0 && (
                  <div style={{ width: "100%" }}>
                    <strong>Archivos cargados:</strong>
                    <ul
                      style={{
                        listStyle: "none",
                        padding: 0,
                        marginTop: "10px",
                        display: "flex",
                        flexDirection: "column",
                        gap: "10px",
                      }}
                    >
                      {archivos.map(({ nombre, url }) => {
                        const ext = nombre.split(".").pop().toLowerCase();
                        const { icon, color } = obtenerIcono(ext);

                        return (
                          <li
                            key={nombre}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "5px",
                              padding: "10px",
                              border: "1px solid #ddd",
                              borderRadius: "5px",
                              boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                              backgroundColor: "#f9f9fb",
                            }}
                          >
                            <i
                              className={`bi ${icon}`}
                              style={{
                                color,
                                fontSize: "1.5rem",
                                flexShrink: 0,
                              }}
                            />
                            <span style={{ flexGrow: 1 }}>{nombre}</span>
                            <button
                              onClick={(e) => {
                                e.preventDefault();
                                descargarArchivo(url, nombre);
                              }}
                              style={{
                                color: "#007bff",
                                background: "none",
                                border: "none",
                                fontWeight: "bold",
                                cursor: "pointer",
                              }}
                            >
                              <i
                                className="bi bi-download"
                                style={{ fontSize: "20px" }}
                              />
                            </button>
                            <button
                              onClick={() => eliminarArchivo(nombre)}
                              style={{
                                border: "none",
                                background: "transparent",
                                color: "#dc3545",
                                cursor: "pointer",
                              }}
                            >
                              <i
                                className="bi bi-trash"
                                style={{ fontSize: "20px" }}
                              />
                            </button>
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Grupo de botones: Guardar como borrador, Guardar y enviar, Cancelar */}
          <div className="cotizacion-toolbar">
            <div className="btn-group">
              <button
                id="guardar-enviar"
                className="btn btn-primary"
                type="submit"
                onClick={guardar}
              >
                {modoEdicion ? "Actualizar" : "Guardar y enviar"}
              </button>
              <button
                id="cancelar"
                className="btn btn-secondary"
                type="button"
                onClick={handleCancel}
              >
                Cancelar
              </button>
            </div>
          </div>
        </form>

        {mostrarTabla && <TablaRemisiones remisiones={props.remisiones} />}
      </div>

      <NumeroConfigModalUI />
    </>
  );
}

export default RemisionForm;
